import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Privacy from '../../components/Privacy/Privacy';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

const Honoraires = () => {
	return (
		<>
			<Navbar />
			<PageTitle
				pageTitle={'Politique de protection des données'}
				pagesub={'Politique de protection des données'}
			/>
			<Privacy />
			<Footer />
			<Scrollbar />
		</>
	);
};
export default Honoraires;
